import apiClient from './client';
import {OwnerContextResponseMessage} from '@/types/OwnerContextResponse';

/**
 * Fetches the context data for a given music owner, optionally filtered by class and lingo.
 * Chooses secure or public endpoint based on authentication state.
 * @param musicOwner Owner identifier
 * @param titleClass Optional trait/category filter
 * @param titleLingo Optional language filter
 * @param secure Whether to use secure (/secure) or public (/public) endpoint
 */
export async function fetchOwnerContext(
  musicOwner: string,
  titleClass?: string,
  titleLingo?: string,
  secure: boolean = true
): Promise<OwnerContextResponseMessage> {
  const params: Record<string, string> = {};
  if (titleClass) params.titleClass = titleClass;
  if (titleLingo) params.titleLingo = titleLingo;
  const prefix = secure ? '/secure/owner/context' : '/public/owner/context';
  const response = await apiClient.get<OwnerContextResponseMessage>(
    `${prefix}/${encodeURIComponent(musicOwner)}`,
    { params }
  );
  return response.data;
}
